import { render, staticRenderFns } from "./PainelDiplan.vue?vue&type=template&id=b5e9af1e"
import script from "./PainelDiplan.vue?vue&type=script&lang=js"
export * from "./PainelDiplan.vue?vue&type=script&lang=js"
import style0 from "./PainelDiplan.vue?vue&type=style&index=0&id=b5e9af1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports